//
// Site Help functions
//
export default class SiteHelp {
  constructor() {

    this.helpPanelMask = document.getElementById('site-help-mask');
    this.helpPanel = document.getElementById('js-site-help');
    this.helpPanelTriggers = document.querySelectorAll('.js-site-help-toggle');

    this.init();
  }

  init() {
    this.addEventHandling();
  }

  /**
   * @public
   */
   toggleHelpPanel(event) {
    event.preventDefault();

    // Add active class to Panel and Mask (note: do not apply to body element in this situation)
    if (this.helpPanel.classList.contains('site-help--open')) {
      this.helpPanel.classList.remove('site-help--open');
      this.helpPanelMask.classList.remove('site-help-mask--visible');
    } else {
      this.helpPanel.classList.add('site-help--open');
      this.helpPanelMask.classList.add('site-help-mask--visible');

      // TEMPORARY: While we only have one form, click the first item in the list
      let siteHelpTemporaryLink = document.getElementById('js-site-help-temporary-click-single-option');
      if (siteHelpTemporaryLink) {
        siteHelpTemporaryLink.click();
      }
    }
  }

  addEventHandling() {
    this.helpPanelTriggers.forEach(helpPanelTrigger => {
      helpPanelTrigger.addEventListener('click', this.toggleHelpPanel.bind(this));
    });
  }
}